import { render, staticRenderFns } from "./ExtraRequests.vue?vue&type=template&id=78155c8c&"
import script from "./ExtraRequests.vue?vue&type=script&lang=js&"
export * from "./ExtraRequests.vue?vue&type=script&lang=js&"
import style0 from "./ExtraRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports